<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;;line-height: 50px">
        <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addCard()">添加</el-button>
        <span>老人卡号：</span><el-input size="small" placeholder="输入老人卡号" style="width: 250px"></el-input>
        <span> 老人姓名：</span><el-input size="small" placeholder="输入老人姓名" style="width: 250px"></el-input>
        <span> 卡状态：</span><el-select v-fixZoom size="small" style="width: 100px" v-model="cardStatus" placeholder="请选择">
          <el-option v-for="item in cardStatusArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button size="small" type="success" @click="queryDataTable">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="编号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="elderly_card_id"
            label="卡号"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="person_status_code"
            label="状态"
            min-width="60"
            align="center">
          </el-table-column>
          <el-table-column
            prop="elderly_name"
            label="姓名"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="identity_number"
            label="身份证号"
            min-width="120"
            align="center">
          </el-table-column>
          <el-table-column
            prop="validity_date"
            label="有效期"
            min-width="120"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editCard(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delCard(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleCard }}</span>
        <div class="line-title"></div>
        <old-card :cardRow="cardRow" v-model="addEditShow"></old-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import oldCard from './components/oldCard'
// import {queryelderlycardinfo} from '../../api/yanglaoyuan'

export default {
  name: 'oldCardManagement',
  components: {oldCard},
  data () {
    return {
      cardStatus: 0,
      cardStatusArr: [
        {id: 0, name: '全部'},
        {id: 1, name: '未绑定'},
        {id: 2, name: '已绑定'},
        {id: 3, name: '已挂失'},
        {id: 4, name: '已过期'},
        {id: 5, name: '已作废'},
        {id: 6, name: '已删除'}
      ],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 0}],
      titleCard: '',
      addEditShow: false,
      cardRow: {
        row: '',
        isAdd: true
      }
    }
  },
  methods: {
    addCard () {
      this.titleCard = '添加老年卡'
      this.cardRow.isAdd = true
      this.addEditShow = true
    },
    editCard (row) {
      this.titleCard = '编辑老年卡'
      this.cardRow.isAdd = false
      this.cardRow.row = row
      this.addEditShow = true
    },
    delCard (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该老年卡【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {})
    },
    queryDataTable () {},
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/oldCardManagement.vue